import { useTranslation } from 'react-i18next';
import classes from './DashedCard.module.scss';

export default function DashedCard({ children, discardText, confirmText }) {
  const { t } = useTranslation('panel');
  return (
    <div className={classes.dashboard}>
      {children}
      <div className={classes.buttons}>
        <button className={`${classes.discard} ${classes.button}`}>
          {t(discardText)}
        </button>
        <button className={`${classes.confirm} ${classes.button}`}>
          {t(confirmText)}
        </button>
      </div>
    </div>
  );
}
